//ES6 not supported by gatsby
const layouts = {
  ABOUT: "about",
  PROJECT_PAGE: "projectPage",
  PROJECTS: "projects",
  MAIN: "main",
  NOT_FOUND_404: "404",
}

module.exports = layouts
